import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { GetVersionsByIdData } from "../../../lib/data";
import EditApiVersionUi from "../../../ui/versionsUi/editVersionsUi";
import i18n from "../../../lib/i18n";

export default function EditApiVersion() {
    const { id } = useParams();
    const [data, setData] = useState(null);
    const t = i18n.t.bind(i18n); 

    useEffect(() => {
        handleApi();
    }, []);

    const handleApi = async () => {
        const result = await GetVersionsByIdData(id);
        setData(result);
    };

    return (
        <div className="p-5 mx-6 my-3 rounded-lg bg-thirdly">
            <div>
                <h1 className="sm:text-[30px] text-[24px] text-center text-gray pt-1 sm:pb-8 pb-4">
                    {t("edit_page_title.versions") || "Edit API Version"}
                </h1>
                {data ? <EditApiVersionUi data={data} /> : <div className="text-center text-white">Loading...</div>}
            </div>
        </div>
    );
};